module.exports = __webpack_public_path__ + "static/media/samples.0822e8eb.svg";